var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "div",
      {
        staticClass: "participant p-2 indigo white--text text-uppercase",
      },
      [_vm._v("\n    " + _vm._s(_vm.participant_name) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "d-flex flex-column mt-4",
        attrs: {
          id: "message-list",
        },
      },
      [
        _vm.is_loading
          ? _c("v-progress-linear", {
              attrs: {
                indeterminate: "",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.messages, function (message) {
          return _c("agent-message", {
            key: message.id,
            attrs: {
              message: message,
              me: _vm.me,
            },
          })
        }),
        _vm._v(" "),
        _c("v-textarea", {
          staticClass: "mt-auto message-textfield",
          staticStyle: {
            "background-color": "#fefefe",
          },
          attrs: {
            filled: "",
            "full-width": "",
            "auto-grow": "",
            rows: "1",
            "hide-details": "",
            clearable: "",
            label: "ข้อความ...",
            multiple: "true",
          },
          on: {
            keyup: function ($event) {
              if (!$event.type.indexOf("key") && $event.keyCode !== 13)
                return null
              return _vm.sendMessage.apply(null, arguments)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "append",
              fn: function () {
                return [
                  _c(
                    "v-icon",
                    {
                      staticClass: "px-4",
                      on: {
                        click: _vm.sendMessage,
                      },
                    },
                    [_vm._v("\n          mdi-send\n        ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.message,
            callback: function ($$v) {
              _vm.message = $$v
            },
            expression: "message",
          },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }